import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useInstitutions } from '../institutions/Institutions';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});
  const handleChange = (e) => {
    setEntries({
      ...entries,
      [e.target.name]: e.target.value,
    });
  };

  return {
    entries,
    handleChange,
  };
}

export function CreateCoordinator(props) {
  const classes = useStyles();
  const { entries, handleChange } = useForm();
  const { institutions } = useInstitutions();
  const navigate = useNavigate();

  const handleCreate = () => {
    fetch('https://api.edicionesmilenio.com/api/coordinators', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(entries),
    })
      .then(() => {
        navigate('/admin/coordinators');
      })
      .catch((error) => {
        console.error(error);
        window.alert('Error al crear el coordinador, intente de nuevo');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás crear un nuevo
        coordinador autorizado por la editorial para cada institución educativa,
        completa los campos para realizar el proceso correctamente.
      </p>
      <TextField
        className={classes.input}
        id="email"
        label="Correo electrónico"
        type="email"
        variant="outlined"
        name="email"
        onChange={handleChange}
        value={entries?.email}
      />
      <TextField
        className={classes.input}
        id="password"
        label="Contraseña"
        type="password"
        variant="outlined"
        name="password"
        onChange={handleChange}
        value={entries?.password}
      />
      <TextField
        className={classes.input}
        id="name"
        label="Nombre"
        type="text"
        variant="outlined"
        name="name"
        onChange={handleChange}
        value={entries?.name}
      />
      <TextField
        className={classes.input}
        id="lastName"
        label="Apellido"
        type="text"
        variant="outlined"
        name="lastName"
        onChange={handleChange}
        value={entries?.lastName}
      />
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution">Institución</InputLabel>
        <Select
          labelId="institution"
          id="institution"
          name="institution"
          value={entries?.institution}
          onChange={handleChange}
          label="Institución"
        >
          {institutions.map((institution) => (
            <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        className={classes.input}
        id="phone"
        label="Teléfono"
        type="text"
        variant="outlined"
        name="phone"
        onChange={handleChange}
        value={entries?.phone}
      />
      <Button
        variant="contained"
        color="primary"
        className={classes.input}
        disabled={
          !entries?.email ||
          !entries?.password ||
          !entries?.name ||
          !entries?.lastName ||
          !entries?.institution ||
          !entries?.phone
        }
        onClick={handleCreate}
      >
        Crear coordinador
      </Button>
    </div>
  );
}
